export enum ImageType {
  LOGO = 'logo',
  IMAGE1 = 'image1',
  IMAGE2 = 'image2',
  IMAGE3 = 'image3'
}